<template>
  <div>
    <div class="wrap bg-dark">
      <div class="header bg-gradient-primary">
        <div class="separator separator-bottom separator-skew">
          <svg
            x="0"
            y="0"
            viewBox="0 0 2560 100"
            preserveAspectRatio="none"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <polygon
              class="fill-default"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>
      </div>
      <div class="container">
        <div class="row justify-content-center">
          <el-card class="box-card">
            <img src="@/assets/skydropx_logo.svg" class="image" />
            <el-form
              :model="sessionForm"
              ref="sessionForm"
              class="container-inputs"
            >
              <div v-if="message != ''">
                <el-alert :title="message" type="error" show-icon></el-alert>
              </div>

              <el-form-item
                prop="email"
                :rules="[
                  {
                    required: true,
                    message: 'Por favor ingrese su correo',
                    trigger: 'blur',
                  },
                  {
                    type: 'email',
                    message: 'Por favor ingrese un correo valido',
                    trigger: ['blur', 'change'],
                  },
                ]"
              >
                <el-input v-model="sessionForm.email" placeholder="Email">
                  <i slot="suffix" class="el-input__icon el-icon-message"></i>
                </el-input>
              </el-form-item>

              <el-form-item
                prop="password"
                :rules="[
                  {
                    required: true,
                    message: 'Por favor ingrese contraseña',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="sessionForm.password"
                  placeholder="Password"
                  show-password
                ></el-input>
              </el-form-item>

              <el-button type="primary" @click="submitForm('sessionForm')"
                >Entrar</el-button
              >
            </el-form>
          </el-card>
        </div>
        <div class="footer">
          El sistema al que estás intentando acceder está disponible sólo a
          personal con Autorización de Nivel 4/2000. Esta autorización no está
          incluida en el protocolo de seguridad general de Nivel 4. El intento
          de acceso más allá de este punto sin la autorización necesaria es
          causal de eliminación del empleo en la organización y la cancelación
          de todos los beneficios educacionales, médicos y de jubilación. Por
          medio de la presentación de tus credenciales de usuario, das el
          consentimiento para realizar un escaneo de actividad neuronal. En caso
          de acceso no autorizado, esta consola se volverá inoperable. El
          Personal de Seguridad será despachado para reanimarte y escoltarte a
          una celda de detención para interrogación.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { CSApi } from "@/libraries/api";

export default {
  name: "Login",
  components: {},
  data() {
    return {
      message: "",
      sessionForm: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    ...mapActions(["save_session"]),
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            const body = {
              email: this.sessionForm.email,
              password: this.sessionForm.password,
            };
            const response = await CSApi().post(`/coverage/user/login`, body);
            const { data } = response.data;

            this.save_session(data.token);
            this.$router.push({
              name: "Inicio",
            });
          } catch (error) {
            this.message = "ADVERTENCIA: Credenciales incorrectas";
          }
        } else {
          this.message = "Intento de Intrusion ilegal detectado";
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.image {
  margin: 15px 0px;
  width: 100%;
}
.el-card {
  position: absolute;
  top: 25%;
  background-color: #f7fafc;
  border: 1px solid #f7fafc;
  padding: 30px 40px;
  width: 300px;
}

.container-inputs {
  padding: 25px 0px 50px 0px;
}

.el-input {
  margin: 10px 0px;
}

.el-button {
  width: 100%;
}

.wrap {
  /* Set the height to match that of the viewport. */
  height: 100vh;

  /* Set the width to match that of the viewport. */
  width: 100vw;

  /* Remove any browser-default margins. */
  margin: 0;
}

.bg-gradient-primary {
  background: linear-gradient(50deg, #f5365c 0, #4e34e0 100%);
}

.bg-dark {
  background: #07182c;
}

.header {
  position: relative;
  height: 35vh;
}

.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 15px;
  padding-left: 15px;
}

.separator {
  position: absolute;
  top: auto;
  right: 0;
  left: 0;
  overflow: hidden;
  width: 100%;
  height: 100px;
  transform: translateZ(0);
  pointer-events: none;
}

.justify-content-center {
  justify-content: center;
}

.row {
  display: flex;
  margin-right: -15px;
  margin-left: -15px;
  flex-wrap: wrap;
}

.separator-bottom {
  top: auto;
  bottom: 0;
}
.separator svg polygon {
  fill: #07182c;
}

.separator svg {
  position: absolute;
  bottom: 0px;
}

.footer {
  position: absolute;
  bottom: 5px;
  padding: 9px;
  color: #3b60a2;
  text-align: center;
  font-size: 12px;
}
</style>
